import { Carousel, Image } from "antd";
import "../../Styles/Web.css"
import { CheckCircleFilled, CheckCircleTwoTone, StarFilled, StarOutlined } from "@ant-design/icons";

export const WebDescription = ({title, location, color}) => {

    return (
        
        <div className="block" style={{background:`${color}15`}}>
            <div>
                {
                    <div>
                        <h1 className="block-title">{title}</h1>
                        <h3 style={{color:`${color}`}}>{location.categories?.primaryCategory?.displayName}</h3>
                        {location.description}
                    </div>
                }                
            </div>
            <br/>
            <div style={{display:'flex', justifyContent:'space-between', flexWrap:'wrap'}}>
                {
                    location.serviceItems?.serviceItems.map((service) => (
                        <h3 style={{margin:'10px'}} ><CheckCircleFilled style={{color:`${color}cc`}}/> {service.name}</h3>
                    ))
                }
            </div>
        </div>
    )
}